import { isBlank } from "../util/ext";
import { includes } from "ramda";

export const getProjectUrl = project => {
  if (isBlank(project.landingPageTemplate)) {
    return "Legacy URL from S3";
  } else if (
    includes(project.projectId, [
      "11e5115a-f512-402f-99f8-905a27f64f2f", // Keys to Palestine
      "ea1c952d-5066-4285-b875-252498af4ca7", // Write to Inspire
      "b60c5d55-6bd6-410e-a7d4-a671a42d565a", // Speaking with Impact
    ])
  ) {
    // Add lang=ar to QNL arabic projects
    return `https://${project.program.programKey}.librariesshare.com/${project.projectKey}?lang=ar`;
  } else if (
    includes(project.landingPageTemplate, [
      "landing-page",
      "landing-page-iap-contest",
      "landing-page-rtl",
      "landing-page-qnl",
      "landing-page-rtl-qnl",
    ])
  ) {
    return `https://${project.program.programKey}.librariesshare.com/${project.projectKey}`;
  } else {
    return `https://${project.program.programKey}.librariescreate.com/${project.projectKey}`;
  }
};
